import { Controller } from '@hotwired/stimulus'

/**
 * Adds/removes rows of content from a template into a container
 * Usage:
 *   <div data-controller="dynamic-form-rows">
 *     <template data-dynamic-form-rows-target="template">
 *       <div class="dynamic-row">
 *         <!-- Row content -->
 *         <button data-action="dynamic-form-rows#removeRow">Remove</button>
 *       </div>
 *     </template>
 *     <div data-dynamic-form-rows-target="container">
 *       <!-- rows will be added here -->
 *     </div>
 *     <button data-action="dynamic-form-rows#addRow">Add Row</button>
 *   </div>
 */
export default class extends Controller {
    static targets = ['template', 'container']

    addRow() {
        const content = this.templateTarget.innerHTML
        // (Optionally) Generate a unique ID for a new input field inside <template />
        // For ex: input[name="pixel[header_rows_attributes][NEW_RECORD]"]
        const uniqueId = Date.now()
        const replaced = content.replaceAll('NEW_RECORD', uniqueId)
        this.containerTarget.insertAdjacentHTML('beforeend', replaced)
    }

    removeRow(event) {
        const row = event.target.closest('.dynamic-row')
        const destroyInput = row.querySelector('[data-destroy-field]')
        if (destroyInput) {
            destroyInput.value = '1'
            row.classList.add('d-none')
        } else {
            row.remove()
        }
    }
}
